import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AppNavItem, AppNavTreeItem } from "@lantern/app/models";

import { AppConfig } from "../app.config";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class AppNavService {
  constructor(private auth: AuthService, private app: AppConfig) {}

  filteredMenu$: Observable<AppNavItem[]> = this.auth.isLoggedIn.pipe(
    map((loggedIn) => this.filterMenuItems(this.app.menu, loggedIn))
  );
  filteredHeaderMenu$: Observable<AppNavItem[]> = this.auth.isLoggedIn.pipe(
    map((loggedIn) => this.filterMenuItems(this.app.headerMenu, loggedIn))
  );

  private filterMenuItems(
    items: AppNavItem[] = [],
    loggedIn: boolean = false
  ): AppNavItem[] {
    if (loggedIn && this.hasAppAccess()) {
      return this.parseMenuWithAuth(items);
    } else {
      return [];
    }
  }

  private hasAppAccess(): boolean {
    return (
      !this.app.auth.appAuthCheck || this.auth.hasApplication(this.app.name)
    );
  }

  private parseMenuWithAuth(items: AppNavItem[] = []): AppNavItem[] {
    return items
      .filter((item) => {
        if (item.application && item.feature) {
          return this.auth.hasFeature(item.feature, item.application);
        } else if (item.feature) {
          return this.auth.hasFeature(item.feature);
        } else if (item.application) {
          return this.auth.hasApplication(item.application);
        } else {
          return true;
        }
      })
      .map((item) => {
        if (!item.hasOwnProperty("items")) {
          return item;
        }

        // if tree item, clone and check auth for child items
        let clone: AppNavTreeItem = Object.assign({}, item as AppNavTreeItem);
        (clone as AppNavTreeItem).items = this.parseMenuWithAuth(clone.items);
        return clone;
      });
  }
}
